import { order, orderService, returnService, configService } from './order';
import { decisionCodeService } from './decisionCodeService';
import { creditNoteService } from './creditNoteService';
import { setLanguage } from './languageStore';
import graph from './graph';
import { skuLocation } from './skuLocation';

const services = {
    // Legacy support (deprecated)
    order,
    
    // New services
    orderService,
    returnService,
    configService,
    decisionCodeService,
    creditNoteService,
    
    // Other services
    graph,
    skuLocation,
    
    // Utilities
    setLanguage,
};

export default services;

// Named exports for direct imports
export { order, orderService, returnService, configService, decisionCodeService, creditNoteService, setLanguage, graph, skuLocation };
